import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import { BrowserRouter } from 'react-router-dom';
import '@splidejs/react-splide/css';
// or other themes
import '@splidejs/react-splide/css/core';

// <!-- Required CSS Libraries -->
import './vendor/bootstrap/css/bootstrap.min.css';
import './vendor/fontawesome/css/all.min.css';
import './vendor/normalize-css/normalize.css';

// // <!-- Extra Libraries -->
import './vendor/splidejs/css/splide.min.css';
import './vendor/splidejs/css/themes/splide-skyblue.min.css';

// // <!-- Custom CSS -->
import './css/style.css';
import './css/responsive.css';

// !-- Required JS File -->
// import './vendor/jQuery/jquery.min.js';
// import './vendor/modernizr/modernizr-3.11.2.min.js';
// import './vendor/bootstrap/js/bootstrap.bundle.min.js';

// <!-- Extra Libraries -->
// import './vendor/splidejs/js/splide.min.js';

// <!-- Custom JS -->
// import './component/js/custom';


ReactDOM.render(
  <React.StrictMode>
        <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
